export const FILE_OWNER_IS_USER_LOGGED_IN = 'me';
